import '.a{display:flex;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.b7{min-height:100vh;}.ssr-plugin'
import '.b8{margin-bottom:2rem;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import '.b4{margin-bottom:5rem;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import Footer from '@app/components/blocks/footer/Footer'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Head } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { rootDomain } from '@app/util/links'

export const PageLayout = ({
  gap = '1rem',
  standardPageTitle = true,
  children,
  marginTop = '2rem',
  style,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  standardPageTitle?: boolean
  children: ReactNode
  marginTop?: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  const [location] = useLocation()
  return (
    <styled.div className="a n b m ae"
      style={{
        ...style,
      }}
    >
      {standardPageTitle && (
        <Head>
          <title>CrowdBuilding</title>
        </Head>
      )}
      <Head>
        <link rel="canonical" href={`${rootDomain}${location}`} />
      </Head>
      <TopNavBar />
      <div className="b7 b8 b5"
        style={{
          width: isMobile ? '100%' : '85%',
          paddingInline: isMobile ? '1rem' : 0,
        }}
      >
        <styled.main className="b4 a m ab"
          style={{
            marginTop,
            gap: gap,
            paddingInline: isMobile ? 0 : '1rem',
          }}
        >
          {children}
        </styled.main>

        <Footer />
      </div>
    </styled.div>
  )
}
